module.exports = "<tag-page></tag-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/tag.html
// module id = 1893
// module chunks = 0